/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Credentials_Permissions_AddInputs */

const es_components_credentials_permissions_add = /** @type {(inputs: Components_Credentials_Permissions_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agregar`)
};

const en_components_credentials_permissions_add = /** @type {(inputs: Components_Credentials_Permissions_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add`)
};

/**
* | output |
* | --- |
* | "Add" |
*
* @param {Components_Credentials_Permissions_AddInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_credentials_permissions_add = /** @type {((inputs?: Components_Credentials_Permissions_AddInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Credentials_Permissions_AddInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_credentials_permissions_add(inputs)
	return en_components_credentials_permissions_add(inputs)
});
export { components_credentials_permissions_add as "components.credentials.permissions.add" }